// extracted by mini-css-extract-plugin
export default {"worker_card":"teacher_worker_card__R02zt","button":"teacher_button__LB9Sq","bg_image":"teacher_bg_image__IfVcv"};